import { Router } from "@frui.ts/screens";
import { attachAutomaticValidator } from "@frui.ts/validation";
import { Modules, newNavigationName } from "config";
import BankAccountEnum, { BankAccountEnumValidationRules } from "entities/bankAccountEnum";
import EnumRepository from "repositories/enumRepository";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import CreateViewModel from "../../createViewModel";
import { BankAccountValidationRules } from "../../../entities/bankAccount";

@Router.registerRoute({ route: newNavigationName, name: Router.Self })
export default class BankAccountCreateViewModel extends CreateViewModel<BankAccountEnum> {
  readonly modelName = "bankAccountEnum";

  constructor(
    protected repository: EnumRepository,
    protected localizationService: LocalizationService,
    protected notificationService: NotificationService,
    protected eventBus: EventBus
  ) {
    super();
    this.navigationName = newNavigationName;
  }

  protected loadDetail() {
    const item = new BankAccountEnum();
    attachAutomaticValidator(item, BankAccountEnumValidationRules, false);
    attachAutomaticValidator(item.bankAccount, BankAccountValidationRules, false);
    return item;
  }

  protected postData() {
    return this.repository.create<BankAccountEnum>(this.item, "bank_accounts", BankAccountEnum);
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `bankAccounts.${code}`, size);
  }
}
